module.exports = __webpack_public_path__ + "static/media/burrito_01_full.c5b811dd.gif";